import { useEffect } from 'react';
import { createUpdateEffect } from './createUpdateEffect.js';

// src/hooks/useUpdateEffect.ts
var useUpdateEffect = createUpdateEffect(useEffect);

export { useUpdateEffect };
